export default "__VITE_ASSET__DfAqCkrd__"